module.exports = __webpack_public_path__ + "static/media/TS_ThemeBox_DenimDrawer.8b8f9c2d.jpg";